var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"panorama"}},[_c('img',{staticClass:"w-100 h-100",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.src,"alt":"Preview"}})])}
var staticRenderFns = []

export { render, staticRenderFns }